import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import {
  CAN_REDO_COMMAND,
  CAN_UNDO_COMMAND,
  COMMAND_PRIORITY_CRITICAL,
  REDO_COMMAND,
  UNDO_COMMAND,
  INDENT_CONTENT_COMMAND,
  OUTDENT_CONTENT_COMMAND,
  FORMAT_ELEMENT_COMMAND,
} from 'lexical';
import { useEffect, useState } from 'react';
import { BiUndo, BiRedo } from 'react-icons/bi';
import { IS_APPLE } from '../../shared/environment';
import { mergeRegister } from '@lexical/utils';
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  MenuOutlined,
  AlignLeftOutlined,
  AlignCenterOutlined,
  AlignRightOutlined,
  // TableOutlined,
  // FileImageOutlined
} from '@ant-design/icons';
import vi from '../../locales/vi.json';
import { styled } from '@stitches/configed';

export const ToolbarPlugin = () => {
  const [editor] = useLexicalComposerContext();
  const [canUndo, setCanUndo] = useState(false);
  const [canRedo, setCanRedo] = useState(false);

  useEffect(() => {
    return mergeRegister(
      // editor.registerEditableListener((editable) => {
      //   setIsEditable(editable);
      // }),
      // editor.registerUpdateListener(({ editorState }) => {
      //   editorState.read(() => {
      //     $updateToolbar();
      //   });
      // }),
      editor.registerCommand<boolean>(
        CAN_UNDO_COMMAND,
        (payload) => {
          setCanUndo(payload);
          return false;
        },
        COMMAND_PRIORITY_CRITICAL,
      ),
      editor.registerCommand<boolean>(
        CAN_REDO_COMMAND,
        (payload) => {
          setCanRedo(payload);
          return false;
        },
        COMMAND_PRIORITY_CRITICAL,
      ),
    );
  }, [editor]);

  return (
    <div className="editor-toolbar">
      <button
        disabled={!canUndo}
        onClick={() => {
          editor.dispatchCommand(UNDO_COMMAND, undefined);
        }}
        title={IS_APPLE ? vi.undo + ' (⌘Z)' : vi.undo + ' (Ctrl+Z)'}
        type="button"
        className="toolbar-item spaced"
        aria-label={vi.undo}
      >
        <BiUndo />
      </button>
      <button
        disabled={!canRedo}
        onClick={() => {
          editor.dispatchCommand(REDO_COMMAND, undefined);
        }}
        title={IS_APPLE ? vi.redo + ' (⌘Z)' : vi.redo + ' (Ctrl+Z)'}
        type="button"
        className="toolbar-item spaced"
        aria-label={vi.redo}
      >
        <BiRedo />
      </button>

      <Divider />

      <button
        onClick={() => {
          editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'left');
        }}
        title={vi.left}
        type="button"
        className="toolbar-item spaced"
        aria-label={vi.left}
      >
        <AlignLeftOutlined />
      </button>
      <button
        onClick={() => {
          editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'center');
        }}
        title={vi.center}
        type="button"
        className="toolbar-item spaced"
        aria-label={vi.center}
      >
        <AlignCenterOutlined />
      </button>
      <button
        onClick={() => {
          editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'right');
        }}
        title={vi.right}
        type="button"
        className="toolbar-item spaced"
        aria-label={vi.right}
      >
        <AlignRightOutlined />
      </button>
      <button
        onClick={() => {
          editor.dispatchCommand(FORMAT_ELEMENT_COMMAND, 'justify');
        }}
        title={vi.justify}
        type="button"
        className="toolbar-item spaced"
        aria-label={vi.justify}
      >
        <MenuOutlined />
      </button>

      <Divider />

      <button
        onClick={() => {
          editor.dispatchCommand(OUTDENT_CONTENT_COMMAND, undefined);
        }}
        title={vi.outdent}
        type="button"
        className="toolbar-item spaced"
        aria-label={vi.outdent}
      >
        <MenuFoldOutlined />
      </button>
      <button
        onClick={() => {
          editor.dispatchCommand(INDENT_CONTENT_COMMAND, undefined);
        }}
        title={vi.indent}
        type="button"
        className="toolbar-item spaced"
        aria-label={vi.indent}
      >
        <MenuUnfoldOutlined />
      </button>

      {/* <Divider /> */}
      {/* <button */}
      {/*   onClick={() => { */}
      {/*     editor.dispatchCommand(INDENT_CONTENT_COMMAND, undefined); */}
      {/*   }} */}
      {/*   title={vi.indent} */}
      {/*   type="button" */}
      {/*   className="toolbar-item spaced" */}
      {/*   aria-label={vi.indent} */}
      {/* > */}
      {/*   <TableOutlined /> */}
      {/* </button> */}
      {/* <button */}
      {/*   onClick={() => { */}
      {/*     editor.dispatchCommand(INDENT_CONTENT_COMMAND, undefined); */}
      {/*   }} */}
      {/*   title={vi.indent} */}
      {/*   type="button" */}
      {/*   className="toolbar-item spaced" */}
      {/*   aria-label={vi.indent} */}
      {/* > */}
      {/* <FileImageOutlined /> */}
      {/* </button> */}
    </div>
  );
};

const Divider = styled('div', {
  width: 1,
  backgroundColor: '#eee',
  margin: '0 4px',
});
